export const API_GEOCODER_ADDRESS_SUGGESTIONS_ROUTE = '/api/geocoder/address-suggestion';
